<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h5>Daily Report</h5>
                        </div>
                        <div class="card-body">
                            <div class="row gutters">
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">Date</div>
                                        <input class="form-control form-control-sm" type="date" v-model="meta.date" />
                                        <span v-if="errors.date" class="invalid-feedback">{{ errors.date[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <search
                                            :class="{ 'is-invalid': errors.department_id }"
                                            :customClass="{ 'is-invalid': errors.department_id }"
                                            :initialize="meta.department_id"
                                            id="department_id"
                                            label="department_name"
                                            placeholder="Select Department"
                                            :data="departments"
                                            @input="departments => meta.department_id = departments"
                                        >
                                        </search>
                                        <span v-if="errors.department_id" class="invalid-feedback">{{ errors.department_id[0] }}</span>
                                        <div class="field-placeholder">Department</div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <search
                                            :class="{ 'is-invalid': errors.functional_id }"
                                            :customClass="{ 'is-invalid': errors.functional_id }"
                                            :initialize="meta.functional_id"
                                            id="functional_id"
                                            label="functional_name"
                                            placeholder="Select Functional"
                                            :data="functionals"
                                            @input="functionals => meta.functional_id = functionals"
                                        >
                                        </search>
                                        <span v-if="errors.functional_id" class="invalid-feedback">{{ errors.functional_id[0] }}</span>
                                        <div class="field-placeholder">Functional</div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <search
                                            :class="{ 'is-invalid': errors.frequency_id }"
                                            :customClass="{ 'is-invalid': errors.frequency_id }"
                                            :initialize="meta.frequency_id"
                                            id="frequency_id"
                                            label="frequency_name"
                                            placeholder="Select Frequency"
                                            :data="frequencies"
                                            @input="frequencies => meta.frequency_id = frequencies"
                                        >
                                        </search>
                                        <span v-if="errors.frequency_id" class="invalid-feedback">{{ errors.frequency_id[0] }}</span>
                                        <div class="field-placeholder">Frequency</div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="input-group field-wrapper">
                                        <input class="form-control" type="text" placeholder="Search for Template Name" v-model="meta.search" />
                                        <span class="input-group-text"> <i class="fas fa-search"></i> </span> &nbsp;
                                        <div class="field-placeholder">Template Name</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end">
                                    <button type="button" class="btn btn-primary" @click="search">
                                        Search
                                    </button>
                                    <button type="button" class="btn btn-danger" @click="reset">
                                        Reset
                                    </button>
                                    <a target="_blank" :href="$store.getters.pdfUrl+'report/daily?plant_id='+meta.plant_id+'&date='+meta.date+'&department_id='+meta.department_id+'&functional_id='+meta.functional_id+'&frequency_id='+meta.frequency_id+'&search='+meta.search+'&report_type=PDF'" class="btn btn-success">
                                        PDF
                                    </a>
                                    <a target="_blank" :href="$store.getters.pdfUrl+'report/daily?plant_id='+meta.plant_id+'&date='+meta.date+'&department_id='+meta.department_id+'&functional_id='+meta.functional_id+'&frequency_id='+meta.frequency_id+'&search='+meta.search+'&report_type=Excel'" class="btn btn-secondary">
                                        Excel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row gutters">
                                <div class="col-sm-12">
                                    <div class="table-responsive tabletop">
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Template Name</th>
                                                    <th>Uploaded (Y/N)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="templates.length==0">
                                                    <td colspan="3" class="text-center">No records found</td>
                                                </tr>
                                                <tr v-for="(template,key) in templates" :key="key">
                                                    <td>{{meta.from+key}}</td>
                                                    <td>{{template.template_name}}</td>
                                                    <td>{{ checkDate(template.user_template) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>                               
                                    </div>
                                    <div class="form-actions-footer">
                                        <div class="text-end row">
                                            <div class="col-sm-2">
                                                <select class="form-control" v-model="meta.per_page" @change="onPerPageChange">
                                                    <option>10</option>
                                                    <option>15</option>
                                                    <option>20</option>
                                                    <option>25</option>
                                                    <option>30</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-10">
                                                <Pagination class="pagination pagination-sm" :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import Search from "@/components/Search.vue";
    import moment from 'moment'
    export default {
        components: { Pagination, Search },
        data() {
            return {    
                meta: {
                    plant_id:this.$store.getters.user.plant_id,
                    date:moment().format('YYYY-MM-DD'),
                    to_date:'',
                    department_id:'',
                    functional_id: '',
                    frequency_id: '',
                    search:'',
                    report_type:'Data',
                    order_by: "asc",
                    field: "template_id",                   
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                },
                templates:[],
                departments: [],
                functionals: [],
                frequencies: [],
                errors:[],
            }
        },
        mounted() {
            let vm = this;
            vm.getDepartment();
            vm.index()
        },

        methods: {
            index() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "report/dailyReport", data:vm.meta })
                .then(function (response) {
                    loader.hide();
                    vm.templates = response.data.data;
                    vm.meta.totalRows = response.data.total;
                    vm.meta.lastPage = response.data.last_page;
                    vm.meta.from = response.data.from;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getDepartment() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "getDepartmentsPlantWise", data:vm.meta })
                .then(function (response) {
                    vm.departments = response.data.data;
                    vm.getFunctions();
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getFunctions() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "getFunctionalsPlantWise", data:vm.meta })
                .then(function (response) {
                    vm.functionals = response.data.data;
                    vm.getFrequencies();
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getFrequencies() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "getFrequenciesPlantWise", data:vm.meta })
                .then(function (response) {
                    vm.frequencies = response.data.data;
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            sort(field) {
                this.meta = field;
                this.meta.order_by = this.meta.order_by=='asc' ? 'desc' : 'asc';
                this.index();
            },
            search() {
                this.meta.page = 1;
                this.index();
            },

            checkDate(user_template) 
            {         
                let vm = this;      
                if(user_template.length>0)
                {   
                    let data = user_template.filter(function (user_temp) {
                        var date = moment(user_temp.date_time).format('yyyy-MM-DD');
                        var today = moment(vm.meta.date).format('yyyy-MM-DD');
                        return date==today
                    });                    
                    if(data.length==0) {
                        return "No";
                    }
                    else {
                        return "Yes";
                    }
                }                 
                else
                {
                     return "No";
                }
            },

            reset() {
                let vm = this;
                vm.meta.date = moment().format('YYYY-MM-DD');
                vm.meta.to_date = '';
                vm.meta.department_id = '';
                vm.meta.functional_id = '';
                vm.meta.frequency_id = '';
                vm.meta.search = '';
                vm.errors = [];
                vm.search()
            }
        }
    }
</script>

<style scoped>
    .btnn {
        margin-top: 0.5rem;
    }
</style>
